import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

let warehouseValidationForm = yup.object().shape({
  name: yup.string().required("Warehouse Name is required"),
  primary_email: yup.string().email().required("Primary Email is required"),
  secondary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true; // skip test if empty
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Secondary Contact is required"),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Primary Contact is required"),
  manager: yup.string().required("Warehouse manager is required"),
  landmark: yup.string().required("Landmark is required"),
});

export { warehouseValidationForm };
